import * as React from 'react';

type Props = {
  children: any,
}

export const ContextScrollTop = React.createContext(null);

class PageContentWrapper extends React.Component<Props> {
  scrollRef;

  constructor(props) {
    super(props);

    this.scrollRef = React.createRef();
  }

  scrollTop = () => {
    this.scrollRef.current.scrollTo(0, 0);
  };

  render() {
    const { children } = this.props;

    return (
      <ContextScrollTop.Provider
        value={this.scrollTop}
      >
        <div
          className="app__view"
          ref={this.scrollRef}
        >
          {children}
        </div>
      </ContextScrollTop.Provider>
    );
  }
}

export default PageContentWrapper;
